var _defs, _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAog135Xxx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    width: 802.12,
    height: 267.38,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs7"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect4",
    fill: "none",
    d: "M229.11 505.27h802.12v267.37H229.11z"
  })), /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:#fff}.cls-2{fill:#2e3192}.cls-5{fill:#fff200}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath)",
    id: "g71",
    transform: "translate(-229.11 -505.27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g69"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    transform: "rotate(-135 706.184 581.33)",
    id: "rect9",
    d: "M305.12 567.75h802.12v27.17H305.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "rotate(-135 730.197 557.319)",
    id: "rect11",
    d: "M329.13 536.94h802.12v40.75H329.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    transform: "rotate(-135 658.165 629.35)",
    id: "rect13",
    d: "M257.1 615.77h802.12v27.17H257.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "rotate(-135 682.172 605.34)",
    id: "rect15",
    d: "M281.11 584.97h802.12v40.75H281.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    transform: "rotate(45 802.22 485.28)",
    id: "rect17",
    d: "M401.17 471.7h802.12v27.17H401.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "rotate(45 826.245 461.272)",
    id: "rect19",
    d: "M425.18 440.9h802.12v40.75H425.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    transform: "rotate(45 754.205 533.312)",
    id: "rect21",
    d: "M353.15 519.72h802.12v27.17H353.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "rotate(45 778.213 509.296)",
    id: "rect23",
    d: "M377.16 488.92h802.12v40.75H377.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    transform: "rotate(-135 898.271 389.241)",
    id: "rect25",
    d: "M497.21 375.66h802.12v27.17H497.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    transform: "rotate(-135 922.284 365.23)",
    id: "rect27",
    d: "M521.22 344.86h802.12v40.75H521.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    transform: "rotate(-135 850.252 437.261)",
    id: "rect29",
    d: "M449.19 423.68h802.12v27.17H449.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "rotate(-135 874.259 413.252)",
    id: "rect31",
    d: "M473.2 392.88h802.12v40.75H473.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    transform: "rotate(45 994.313 293.198)",
    id: "rect33",
    d: "M593.25 279.61h802.12v27.17H593.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    transform: "rotate(45 946.293 341.217)",
    id: "rect35",
    d: "M545.23 327.64h802.12v27.17H545.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    transform: "rotate(45 970.306 317.214)",
    id: "rect37",
    d: "M569.24 296.83h802.12v40.75H569.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    transform: "rotate(-135 322.009 965.502)",
    id: "rect39",
    d: "M-79.05 951.92h802.12v27.17H-79.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    transform: "rotate(-135 346.021 941.491)",
    id: "rect41",
    d: "M-55.04 921.12h802.12v40.75H-55.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    transform: "rotate(-135 298.001 989.511)",
    id: "rect43",
    d: "M-103.06 969.14h802.12v40.75h-802.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    transform: "rotate(45 418.056 869.464)",
    id: "rect45",
    d: "M16.99 855.88h802.12v27.17H16.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "rotate(45 442.064 845.449)",
    id: "rect47",
    d: "M41 825.07h802.12v40.75H41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    transform: "rotate(45 370.036 917.484)",
    id: "rect49",
    d: "M-31.03 903.9h802.12v27.17H-31.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "rotate(45 394.043 893.468)",
    id: "rect51",
    d: "M-7.02 873.1H795.1v40.75H-7.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    transform: "rotate(-135 514.096 773.414)",
    id: "rect53",
    d: "M113.04 759.83h802.12V787H113.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "rotate(-135 538.108 749.403)",
    id: "rect55",
    d: "M137.05 729.03h802.12v40.75H137.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    transform: "rotate(-135 466.078 821.438)",
    id: "rect57",
    d: "M65.01 807.85h802.12v27.17H65.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "rotate(-135 490.09 797.427)",
    id: "rect59",
    d: "M89.03 777.05h802.12v40.75H89.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    transform: "rotate(45 610.144 677.37)",
    id: "rect61",
    d: "M209.08 663.79h802.12v27.17H209.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "rotate(45 634.152 653.354)",
    id: "rect63",
    d: "M233.09 632.99h802.12v40.75H233.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    transform: "rotate(45 562.124 725.39)",
    id: "rect65",
    d: "M161.06 711.81h802.12v27.17H161.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "rotate(45 586.137 701.386)",
    id: "rect67",
    d: "M185.07 681.01h802.12v40.75H185.07z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    id: "rect73",
    d: "M0 240.21h802.12v27.17H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    id: "rect75",
    d: "M0 0h802.12v27.17H0z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAog135Xxx);
export default __webpack_public_path__ + "static/media/AOG135XXX.6386056dddbb11411b785288154784d4.svg";
export { ForwardRef as ReactComponent };